import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ModuleVersionTestCaseRow } from "../types";

const ModuleVersionTestCasesTableDropdownCell = ({
  ...cellProps
}: TableSimpleCellProps<ModuleVersionTestCaseRow>) => {
  return <TableSimpleCell {...cellProps} />;
};

export default ModuleVersionTestCasesTableDropdownCell;
